var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUserManagementIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.887,
    height: 29.435,
    viewBox: "0 0 29.887 29.435",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-management-icon",
    transform: "translate(-1.339 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    "data-name": "Group 1852",
    transform: "translate(1.339 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    "data-name": "Group 1851",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10437",
    "data-name": "Path 10437",
    d: "M.528,20.7l1,1.727H4.761l-1.3-2.254,1.8-2.031A1.4,1.4,0,0,0,5.6,16.99a9.849,9.849,0,0,1,0-3.143A1.4,1.4,0,0,0,5.262,12.7l-1.8-2.031L5.253,7.558,7.917,8.1a1.4,1.4,0,0,0,1.168-.287A9.788,9.788,0,0,1,11.8,6.245a1.4,1.4,0,0,0,.833-.866L13.49,2.8h3.586l.859,2.575a1.4,1.4,0,0,0,.831.866,9.816,9.816,0,0,1,2.716,1.571A1.4,1.4,0,0,0,22.65,8.1l2.663-.545,1.793,3.106L25.3,12.7a1.4,1.4,0,0,0-.335,1.152,9.849,9.849,0,0,1,0,3.143,1.4,1.4,0,0,0,.335,1.152l1.8,2.031-1.3,2.254H29.04l1-1.727a1.4,1.4,0,0,0-.164-1.63l-2.048-2.309a12.288,12.288,0,0,0,0-2.686l2.048-2.3a1.4,1.4,0,0,0,.164-1.632l-2.8-4.855a1.4,1.4,0,0,0-1.494-.673l-3.028.613a12.565,12.565,0,0,0-2.327-1.344L19.4.959A1.4,1.4,0,0,0,18.086,0H12.479a1.4,1.4,0,0,0-1.33.959l-.981,2.924A12.645,12.645,0,0,0,7.841,5.227L4.826,4.609a1.4,1.4,0,0,0-1.494.673l-2.8,4.855a1.4,1.4,0,0,0,.165,1.637l2.045,2.307a12.648,12.648,0,0,0,0,2.686L.694,19.07A1.4,1.4,0,0,0,.528,20.7Z",
    transform: "translate(-0.339)",
    fill: "#0532f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10438",
    "data-name": "Path 10438",
    d: "M5.96,26.625l.756-2.443a.507.507,0,0,1,.488-.36H9.638a3.168,3.168,0,0,0,2.7-4.83l-1.711-2.775a4.205,4.205,0,1,1,7.158,0l-1.71,2.774a3.168,3.168,0,0,0,2.7,4.832H21.2a.508.508,0,0,1,.488.36l.756,2.443h2.935L24.37,23.354A3.3,3.3,0,0,0,21.2,21.018H18.769a.364.364,0,0,1-.31-.561l1.709-2.774a7.008,7.008,0,1,0-11.93,0l1.71,2.774a.365.365,0,0,1-.31.561H7.2a3.3,3.3,0,0,0-3.166,2.335L3.025,26.625Z",
    transform: "translate(0.741 2.81)",
    fill: "#0532f0"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserManagementIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-management-icon.b492e2f7.svg";
export { ForwardRef as ReactComponent };